export default {
  computed: {
    nameLabelCourt() {
      return "Tribunal e Região da Justiça";
    },
    nameLabelJusticeRegion() {
      return "Vara/Comarca";
    }
  }
};
